var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col pr-0 pl-2"
  }, [_vm.date ? _c('span', [_vm.create && !_vm.readOnly ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.date,
      expression: "value.date"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.value.date
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "date", $event.target.value);
      }
    }
  }) : _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": _vm.formatDate(_vm.value.date)
    }
  })]) : _c('span', [_vm.create && !_vm.readOnly ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.week_day,
      expression: "value.week_day"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "disabled": !_vm.create
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "week_day", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option'), _vm._l(_vm.weekdays, function (name, identifier) {
    return _c('option', {
      domProps: {
        "value": identifier
      }
    }, [_vm._v(_vm._s(name))]);
  })], 2) : _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": _vm.weekdays[_vm.value.week_day]
    }
  })])]), _c('div', {
    staticClass: "col pr-0 pl-2"
  }, [!_vm.readOnly ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.is_available,
      expression: "value.is_available"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "is_available", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.isAvailableChanged]
    }
  }, [_vm.create ? _c('option') : _vm._e(), _vm._l(_vm.availableStatus, function (status, value) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(status))]);
  })], 2) : _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": _vm.availableStatus[_vm.value.is_available]
    }
  })]), !_vm.useCutOff ? _c('div', {
    staticClass: "col pr-0 pl-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.from_time,
      expression: "value.from_time",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      'invalid': !_vm.isValid && _vm.isFormFilled
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.timePlaceholder,
      "pattern": "(|0?[0-9]|1[0-9]|2[0-3])[:\\.]([0-5][0-9])",
      "maxlength": "5",
      "readonly": _vm.isTimeReadOnly
    },
    domProps: {
      "value": _vm.value.from_time
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "from_time", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "col pr-0 pl-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.to_time,
      expression: "value.to_time",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    class: {
      'invalid': !_vm.isValid && _vm.isFormFilled
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.timePlaceholder,
      "pattern": "(|0?[0-9]|1[0-9]|2[0-3])[:\\.]([0-5][0-9])",
      "maxlength": "5",
      "readonly": _vm.isTimeReadOnly
    },
    domProps: {
      "value": _vm.value.to_time
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "to_time", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "col pr-0 pl-2"
  }, [!_vm.date ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.value.description,
      expression: "value.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": _vm.readOnly
    },
    domProps: {
      "value": _vm.value.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "description", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }) : !_vm.readOnly ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value.description,
      expression: "value.description"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.value, "description", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option'), _vm._l(_vm.serviceTimeReasons, function (description) {
    return _c('option', {
      domProps: {
        "value": description.trim()
      }
    }, [_vm._v(_vm._s(description))]);
  })], 2) : _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": _vm.value.description
    }
  })]), _vm.usesCapacities ? _c('div', {
    staticClass: "col pr-0 pl-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.value.max_capacity,
      expression: "value.max_capacity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.value.max_capacity
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.value, "max_capacity", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), _vm.$slots['default'] ? _c('div', {
    staticClass: "col-2 px-2"
  }, [_vm._t("default")], 2) : _vm._e(), _vm.isFormFilled && !_vm.isValid && !_vm.readOnly ? _c('div', {
    staticClass: "col-12 mt-2 mb-6"
  }, [_c('OmniAlertInline', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v(" Nog niet alle velden zijn hier goed ingevuld. ")])], 1) : _vm._e(), !_vm.readOnly && _vm.isFormFilled && _vm.isValid && _vm.create ? _c('div', {
    staticClass: "col-12 mt-2 mb-6"
  }, [_c('OmniAlertInline', {
    attrs: {
      "variant": "info",
      "size": "sm"
    }
  }, [_vm._v(" Vergeet niet op de knop te drukken om de nieuwe tijden toe te voegen. ")])], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }